<template>
  <div>
    <div class="dbanner">
      <el-carousel
        arrow="never"
        :interval="3000"
        id="banner"
        ref="homeban"
        class="home-banner"
        @mouseenter.native="delHandleMouseEnter"
      >
        <el-carousel-item v-for="item in bannerlist" :key="item.id">
          <div style="height: 100%">
            <img :src="item.img" class="home-banner-img"/>
            <div
              class="bannerBackground"
              :class="item.url ? 'pointer-item' : ''"
              @click="item.url ? jumpTo(item.url) : ''"
            >
              <img
                src="../../static/img/资源 46.png"
                class="ditu"
                v-show="item.state"
              />
              <div class="ditu-bottom" v-show="item.state"></div>
            </div>
            <div class="banner-title">
              <div class="container no_margin">
                <div
                  class="title Bold"
                  :class="language == 'zh' ? '' : 'BoldEn'"
                >
                  <span
                    v-html="language == 'zh' ? item.title : item.titleEn"
                  ></span>
                </div>
                <div class="title Regular">
                  <span
                    v-html="language == 'zh' ? item.content : item.contentEn"
                  ></span>
                </div>
                <el-button
                  type="primary"
                  class="aboutusbtn-banner"
                  @click="item.url ? jumpTo(item.url) : ''"
                >{{ language == "zh" ? "了解更多" : "More" }}
                </el-button
                >
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>

      <img
        src="../../static/img/资源 13.png"
        class="bannerleft"
        @click="prev()"
      />
      <img
        src="../../static/img/资源 10.png"
        class="bannerright"
        @click="next()"
      />
    </div>
    <div class="product" id="product">
      <div class="container">
        <p class="home-title">
          {{ language == "zh" ? "最新产品" : "New Products" }}
        </p>
        <el-row :gutter="50">
          <el-col :xs="24" :sm="24" :md="24" :lg="13" :xl="13">
            <div class="productbanner" id="productbanner">
              <el-carousel
                arrow="never"
                id="banner1"
                :interval="2000"
                @change="changetext"
              >
                <el-carousel-item v-for="item in productlist" :key="item.id">
                  <img
                    :src="item.img"
                    class="banner-img"
                    @click="item.url ? jumpTo(item.url) : ''"
                    :class="item.url ? 'pointer-item' : ''"
                  />
                </el-carousel-item>
              </el-carousel>
              <div class="bannertest" id="bannertest">
                {{ bannertest }}
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="11" :xl="11">
            <div class="show_pc">
              <el-row :gutter="50" style="margin-bottom: 10px" class="phone_el">
                <el-col
                  :span="12"
                  class="banner-right"
                  v-for="(item, i) in newproductlist"
                  :key="i"
                  :style="{ height: pheight }"
                >
                  <img :src="item.img" @click="jumpTo(item.url)"/>
                  <div class="zhezhao" @click="jumpTo(item.url)">
                    <div>
                      {{ language == "zh" ? item.title : item.titleEn }}
                    </div>
                    <div>
                      {{ language == "zh" ? item.content : item.contentEn }}
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="show_phone">
              <el-row :gutter="10" style="margin-bottom: 10px" class="phone_el">
                <el-col
                  :span="12"
                  class="banner-right"
                  v-for="(item, i) in newproductlist"
                  :key="i"
                  :style="{ height: pheight }"
                >
                  <img :src="item.img" @click="jumpTo(item.url)"/>
                  <div class="zhezhao" @click="jumpTo(item.url)">
                    <div>
                      {{ language == "zh" ? item.title : item.titleEn }}
                    </div>
                    <div>
                      {{ language == "zh" ? item.content : item.contentEn }}
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <el-button type="primary" class="moreBtn" @click="navto('/Product')">{{
            language == "zh" ? "更多产品" : "More"
          }}
        </el-button>
      </div>
    </div>
    <div class="aboutus" id="aboutus">
      <div class="container">
        <p class="home-title">
          {{ language == "zh" ? "关于我们" : "About us" }}
        </p>
        <el-row :gutter="0">
          <el-col
            :xs="24"
            :sm="24"
            :md="11"
            :lg="11"
            :xl="11"
            id="about"
            class="about"
          >
            <div class="aboutbox">
              <div class="title">
                <span
                  class="bigtitle"
                  v-html="
                    language == 'zh' ? companyInfo.title : companyInfo.titleEn
                  "
                ></span>
                <div
                  class="smalltitle"
                  :class="
                    language == 'zh' ? 'line-height-zh' : 'line-height-en'
                  "
                >
                  <span
                    v-html="
                      language == 'zh'
                        ? companyInfo.content
                        : companyInfo.contentEn
                    "
                  ></span>
                </div>
              </div>
              <div :class="language == 'zh' ? 'icontext' : 'icontext-en'">
                <div class="item">
                  <div class="top">
                    <img src="../../static/img/资源 35.png"/>
                    {{ language == "zh" ? "我们的愿景" : "Vison" }}
                  </div>
                  <div
                    class="bottom"
                    :class="
                      language == 'zh' ? 'line-height-zh' : 'line-height-en'
                    "
                  >
                    <span
                      v-html="
                        language == 'zh'
                          ? '成为国际一流，</br>行业领先品牌'
                          : 'To be an industry-leading </br>brand in the worldwide.'
                      "
                    ></span>
                  </div>
                </div>
                <div class="item">
                  <div class="top">
                    <img src="../../static/img/资源 34.png"/>
                    {{ language == "zh" ? "我们的使命" : "Mission" }}
                  </div>
                  <div
                    class="bottom"
                    :class="
                      language == 'zh' ? 'line-height-zh' : 'line-height-en'
                    "
                  >
                    <span
                      v-html="
                        language == 'zh'
                          ? '携手员工，客户与合作伙伴，</br>共同推进行业发展，创造社会价值'
                          : 'To create value to industry and society by collaborating with employee, customers and partners.'
                      "
                    ></span>
                  </div>
                </div>
              </div>
              <el-button
                type="primary"
                :class="language == 'zh' ? 'aboutusbtn' : 'aboutusbtn-en'"
                @click="navto('/Aboutus')"
              >{{ language == "zh" ? "了解更多" : "More" }}
              </el-button
              >
            </div>
          </el-col>
          <el-col
            :xs="24"
            :sm="24"
            :md="13"
            :lg="13"
            :xl="13"
            id="about-right"
            class="about-right"
          >
            <img
              src="../../static/img/CompanyPhoto.jpg"
              ref="CompanyPhoto"
              class="CompanyPhoto"
            />
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="application" id="application">
      <div class="container">
        <p class="home-title">
          {{ language == "zh" ? "行业应用" : "Applications" }}
        </p>
        <div class="or-container">
          <div
            class="box"
            :class="eleindex == i ? 'eleactive' : ''"
            v-for="(ele, i) in piclist"
            :key="i"
            @mouseenter="enter(i)"
            @mouseleave="out(i)"
          >
            <img :src="ele.img"/>
            <div class="top">
              {{ language == "zh" ? ele.title : ele.titleEn }}
            </div>
            <div class="account">
              <span>
                {{ language == "zh" ? ele.smallTitle : ele.smallTitleEn }}
              </span>
            </div>
            <div class="bottom">
              <p>
                {{ language == "zh" ? ele.bottomTitle : ele.bottomTitleEn }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contactus" id="contact">
      <div class="container">
        <p class="home-title margin-2">
          {{ language == "zh" ? "联系我们" : "Contact us" }}
        </p>
        <el-row :gutter="0" class="margin-2">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="box">
              <div class="info_div">
                <div class="qiye">
                  <div class="title">
                    {{ language == "zh" ? "企业" : "Company" }}
                  </div>
                  <div class="title">
                    {{ language == "zh" ? "销售" : "Sales" }}
                  </div>
                  <div class="title">
                    {{ language == "zh" ? "地址" : "Add." }}
                  </div>
                </div>
                <div>
                  <div class="info_p_div">
                    <p>{{ contact.otherTel }}</p>
                    <p>{{ contact.otherEmail }}</p>
                  </div>
                  <div class="info_p_div">
                    <p>{{ contact.tel }}</p>
                    <p>{{ contact.email }}</p>
                  </div>
                  <div class="info_p_div">
                    <p>
                      {{
                        language == "zh" ? contact.address : contact.addressEn
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <!-- <div class="qiye"></div>
              <div class="xiaoshou"></div>
              <div class="dizhi"></div> -->
              <div class="flex_div">
                <div v-for="item in SocialList">
                  <div
                    v-if="item.name=='公众号'"
                  >

                    <el-popover
                      placement="top"
                      width="150"
                      transition="none"
                      close-delay="0"
                      trigger="hover"
                    >
                      <img :src="item.url" class="img_div2">
                      <div class="img_div" slot="reference">
                        <img :src="item.img"/>
                      </div>
                    </el-popover>
                  </div>
                  <div class="img_div" v-else
                       @click="jumpTo(language == 'zh' ? item.url:item.nameEn)">
                    <img :src="item.img"/>
                  </div>
                </div>
                <!--                <div class="img_div">-->
                <!--                  <img :src="contact.pic1" />-->
                <!--                  <p-->
                <!--                    v-html="-->
                <!--                      language == 'zh'-->
                <!--                        ? '客服微信'-->
                <!--                        : 'Wechat<br/>Customer Service'-->
                <!--                    "-->
                <!--                  ></p>-->
                <!--                </div>-->
                <!--                <div class="img_div">-->
                <!--                  <img :src="contact.pic2" />-->
                <!--                  <p-->
                <!--                    v-html="-->
                <!--                      language == 'zh'-->
                <!--                        ? '公众号'-->
                <!--                        : 'Wechat<br/>Official Account'-->
                <!--                    "-->
                <!--                  ></p>-->
                <!--                </div>-->
                <!--                <div class="img_div">-->
                <!--                  <img :src="contact.pic3" />-->
                <!--                  <p-->
                <!--                    v-html="-->
                <!--                      language == 'zh'-->
                <!--                        ? '抖音号'-->
                <!--                        : 'Tik Tok<br/>Official Account'-->
                <!--                    "-->
                <!--                  ></p>-->
                <!--                </div>-->
              </div>
            </div>
            <el-button
              type="primary"
              class="infoBtn"
              @click="navto('/CallUs')"
            >{{ language == "zh" ? "更多信息" : "More" }}
            </el-button>

            <el-button
              type="primary"
              class="infoBtn2"
              @click="showInfoDialog"
            >{{ language == "zh" ? "立即询价" : "Request for quotation" }}
            </el-button>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <img
              src="../../static/img/Website Image_0-E-2 Picture.jpg"
              class="contactimg"
            />
          </el-col>
        </el-row>
      </div>
    </div>
    <AskDialog ref="AskDialog" :language="language"></AskDialog>
  </div>
</template>

<script>
import AskDialog from "./AskDialog.vue";

export default {
  components: {AskDialog},
  data() {
    return {
      bannertest: "",
      bannerlist: [],
      bannerlist1: [
        {
          url: "../../static/img/Image_2-A-1SeriesII.jpg",
        },
        {
          url: "../../static/img/Image_2-A-1SeriesII.jpg",
        },
      ],
      clientWight: 0,
      clientWight1: 0,
      eleindex: 0,
      piclist: [],
      productlist: [],
      newproductlist: [],
      pheight: 0,
      contact: {},
      companyInfo: {},
      SocialList: [],
    };
  },
  props: {
    language: {
      type: String,
      default: "",
    },
  },
  mounted() {
    this.Init();
  },
  destroyed() {
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      this.changeSize();
    },
  },
  methods: {
    delHandleMouseEnter() {
      this.$refs.homeban.handleMouseEnter = () => {
      };
    },
    Init() {
      this.getInfo();
      this.getInfo1();
      this.getProduct();
      this.getCompanyInfo();
      this.getNewProduct();
      this.getcallus();
      this.changeSize();
      this.getSocialMsg();
      this.$refs.homeban.handleMouseEnter = () => {
      };
    },
    getSocialMsg() {
      this.$http.get("hdbs/api/social/list").then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.SocialList = response.data.page.list;
          }
        }.bind(this)
      );
    },
    changeSize() {
      // 动态设置背景图的高度为浏览器可视区域高度
      // 首先在Virtual DOM渲染数据时，设置下背景图的高度．
      // 然后监听window的resize事件．在浏览器窗口变化时再设置下背景图高度．
      this.$nextTick(() => {
        this.clientWight = $("#banner").css("width");
        this.clientWight1 = $("#banner1").css("width");
        this.clientWight = this.clientWight.replace("px", "");
        this.clientWight1 = Number(this.clientWight1.replace("px", "")) * 0.67;

        document
          .getElementById("banner")
          .setAttribute("style", "height: " + this.clientWight * 0.56 + "px");
        if (document.body.clientWidth > 769) {
          document
            .getElementById("product")
            .setAttribute("style", "height: " + this.clientWight * 0.56 + "px");
          document
            .getElementById("application")
            .setAttribute("style", "height: " + this.clientWight * 0.56 + "px");
          document
            .getElementById("aboutus")
            .setAttribute("style", "height: " + this.clientWight * 0.56 + "px");
          document
            .getElementById("contact")
            .setAttribute("style", "height: " + this.clientWight * 0.56 + "px");
        }
        document
          .getElementById("banner1")
          .setAttribute("style", "height: " + this.clientWight1 + "px");
        this.pheight = (this.clientWight1 + 50) / 2 + "px";
        document
          .getElementById("about")
          .setAttribute("style", "height: " + this.clientWight * 0.29 + "px");
        document
          .getElementById("about-right")
          .setAttribute("style", "height: " + this.clientWight * 0.29 + "px");
      });
      window.addEventListener("resize", () => {
        this.clientWight = $("#banner").css("width");
        this.clientWight1 = $("#banner1").css("width");
        this.clientWight = this.clientWight.replace("px", "");
        this.clientWight1 = Number(this.clientWight1.replace("px", "")) * 0.67;

        document
          .getElementById("banner")
          .setAttribute("style", "height: " + this.clientWight * 0.56 + "px");
        if (document.body.clientWidth > 769) {
          document
            .getElementById("product")
            .setAttribute("style", "height: " + this.clientWight * 0.56 + "px");
          document
            .getElementById("application")
            .setAttribute("style", "height: " + this.clientWight * 0.56 + "px");
          document
            .getElementById("aboutus")
            .setAttribute("style", "height: " + this.clientWight * 0.56 + "px");
          document
            .getElementById("contact")
            .setAttribute("style", "height: " + this.clientWight * 0.56 + "px");
        }
        document
          .getElementById("banner1")
          .setAttribute("style", "height: " + this.clientWight1 + "px");
        this.pheight = (this.clientWight1 + 50) / 2 + "px";
        document
          .getElementById("about")
          .setAttribute("style", "height: " + this.clientWight * 0.29 + "px");
        document
          .getElementById("about-right")
          .setAttribute("style", "height: " + this.clientWight * 0.29 + "px");
      });
    },
    enter(i) {
      console.log(i);
      this.eleindex = i;
    },
    out(i) {
      this.imgindex = -1;
    },
    changetext(i) {
      this.bannertest =
        this.language == "zh"
          ? this.productlist[i].title
          : this.productlist[i].titleEn;
    },
    jumpTo(url) {
      window.open(url, "_blank");
    },
    navto(path, hidefoot) {
      this.$router.push(path);
      // this.hidefoot = hidefoot
    },
    showInfoDialog() {
      this.$refs.AskDialog.init();
    },
    getInfo() {
      this.$http.get("hdbs/api/publicity/banner/list").then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.bannerlist = response.data.page.list;
          }
        }.bind(this)
      );
    },
    getInfo1() {
      this.$http.get("hdbs/api/publicity/industry/list").then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.piclist = response.data.page.list;
          }
        }.bind(this)
      );
    },
    getCompanyInfo() {
      this.$http.get("hdbs/api/companyinfo/list").then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.companyInfo = response.data.page.list[0];
          }
        }.bind(this)
      );
    },
    getProduct() {
      this.$http
        .get("/hdbs/api/publicity/businessinfo/list", {
          page: 1,
          limit: 4,
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.productlist = response.data.page.list;
              this.bannertest =
                this.language == "zh"
                  ? this.productlist[0].title
                  : this.productlist[0].titleEn;
            }
          }.bind(this)
        );
    },
    getNewProduct() {
      this.$http
        .get("/hdbs/api/publicity/newbusiness/list", {
          page: 1,
          limit: 4,
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.newproductlist = response.data.page.list;
            }
          }.bind(this)
        );
    },
    getcallus() {
      this.$http.get("/hdbs/api/contacts/company", {}).then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.contact = response.data.data[0];
          }
        }.bind(this)
      );
    },
    prev() {
      this.$refs.homeban.prev();
    },
    next() {
      this.$refs.homeban.next();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.dbanner {
  position: relative;

  .bannerright {
    width: 8rem;
    position: absolute;
    cursor: pointer;
    bottom: calc(50% - 88px);
    z-index: 99;
    right: 3.5rem;
    padding: 10rem 3rem;
    border-radius: 6px;
  }

  .ditu {
    position: absolute;
    bottom: 1rem;
    right: 10vw;
    width: 14rem;
    height: 14rem;
    background: var(--mainBlue);
    padding: 1.5rem 1.5rem 3rem;
    border-radius: 6px;
    object-fit: contain;
  }

  .ditu-bottom {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 2rem;
    background: var(--mainBlue);
  }

  .bannerleft {
    width: 8rem;
    position: absolute;
    cursor: pointer;
    bottom: calc(50% - 88px);
    z-index: 99;
    left: 3.5rem;
    padding: 10rem 3rem;
    border-radius: 6px;
  }

  .bannerleft:hover, .bannerright:hover {
    background: rgba(255, 255, 255, 0.15);
  }

  .banner-title {
    position: absolute;
    top: calc(50% - 75px);
    z-index: 99;
    left: 10%;
    color: #fff;

    .Bold {
      font-size: 5.6rem;
      font-family: Bold;
      margin-bottom: 3vh;
      line-height: 1.2;
    }

    .BoldEn {
      font-size: 4.8rem;
    }

    .Regular {
      margin: 0;
      font-size: 2.1rem;
      // margin-bottom: 3vh;
    }
  }
}

.home-banner {
  margin-top: calc(-65px - 6vh);
  height: 108rem;

  /deep/ .el-carousel__indicators--horizontal {
    margin-bottom: 3rem;
  }
}

.home-title {
  color: var(--mainBlue);
  font-size: 3.2rem;
  font-family: Demibold;
  margin: 0 0 10rem 0;
}

.product {
  min-height: 108rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: 100% 100%;
  background-image: url('../../static/img/bg1.jpg');
  background-repeat: round;

  .productbanner {
    box-shadow: 0 20px 30px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    padding: 0 1rem;
    background: #FFF;
  }

  .el-carousel {
    img {
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    }
  }

  .bannertest {
    background: #fff;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    padding: 20px;
    font-size: 1.7rem;
    min-height: 100px;
  }

  .banner-right {
    text-align: center;
    position: relative;
    color: #727171;
    margin-bottom: 5rem;
    transition: all 0.3s;

    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
      background: rgba(255 255 255 0.5);
      box-shadow: 0 20px 30px rgba(0, 0, 0, 0.1);
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.3s;
    }

    .zhezhao {
      position: absolute;
      padding: 10px 0;
      bottom: 2px;
      text-align: left;
      line-height: 10px;
      font-size: 14px;
      background: #fff;
      padding-left: 2rem;
      background: rgba(255, 255, 255, 0.5);
      cursor: pointer;
      left: 25px;
      width: calc(100% - 50px);

      div:first-child {
        font-size: 2.1rem;
      }

      div {
        line-height: 1.3;
        font-size: 1.7rem;
        font-family: Regular;
      }
    }
  }

  .banner-right:hover {
    color: #024580;
    transition: all 0.3s;

    img {
      height: 100%;
      background: rgba(255 255 255 1);
      cursor: pointer;
      color: #024580;
    }

    .zhezhao {
      div {
        font-family: Demibold;
        transition: all 0.3s;
      }
    }
  }

  .productbtn {
    margin-top: 50px;
  }
}

.moreBtn {
  // position: absolute;
  font-size: 2.1rem;
  width: 16rem;
  height: 5rem;
  font-family: Regular;
}

.infoBtn {
  // position: absolute;
  margin-top: 7rem;
  font-size: 2.1rem;
  width: 16rem;
  height: 5rem;
  font-family: Regular;
}

.infoBtn2 {
  // position: absolute;
  margin-top: 7rem;
  margin-left: 4rem;
  font-size: 2.1rem;
  width: auto;
  height: 5rem;
  font-family: Regular;
  animation: myBreath 1.5s linear infinite;
}

@keyframes myBreath {
  0% {
    transform: scale(1.18);
  }
  50% {
    transform: scale(100%);
  }
  100% {
    transform: scale(1.18);
  }
}

.aboutusbtn {
  // position: absolute;
  margin-top: 10rem;
  font-size: 2.1rem;
  width: 16rem;
  height: 5rem;
  font-family: Regular;
}

.aboutusbtn-banner {
  // position: absolute;
  margin-top: 10rem;
  font-size: 2.1rem;
  width: 16rem;
  height: 5rem;
  font-family: Regular;
}

.aboutusbtn-en {
  // position: absolute;
  margin-top: 5rem;
  font-size: 2.1rem;
  width: 16rem;
  height: 5rem;
  font-family: Regular;
}

.about-right {
  min-height: 55rem;
}

.container {
  margin-left: 20rem;
  margin-right: 20rem;
}

.no_margin {
  margin: 0;
}

.aboutus {
  min-height: 108rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: 100% 100%;
  color: #fff;
  background-image: url('../../static/img/Background.jpg');
  background-repeat: round;

  .el-row {
    border-radius: 6px;
    box-shadow: 0 20px 30px rgba(0, 0, 0, 0.3);
  }

  .home-title {
    color: #fff;
  }

  .CompanyPhoto {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  .about {
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    padding: 0 5rem;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    min-height: 55rem;

    .title {
      .bigtitle {
        font-family: Demibold;
        font-size: 2.4rem;
        color: var(--mainBlue);
      }

      .smalltitle {
        margin-top: 20px;
        font-size: 1.7rem;
        color: var(--mainGary);
        line-height: 2;
        text-align: justify;
      }
    }

    .icontext-en {
      display: flex;
      margin-top: 5rem;
      width: 100%;

      .item {
        flex: 1;

        .top {
          font-size: 2.1rem;
          color: #024580;
          font-family: Demibold;

          img {
            width: 3rem;
            margin-right: 10px;
          }
        }

        .bottom {
          margin-top: 2rem;
          color: #727171;
          font-size: 1.7rem;
          line-height: 2;
        }
      }
    }

    .icontext {
      display: flex;
      margin-top: 8rem;
      width: 100%;

      .item {
        flex: 1;

        .top {
          font-size: 2.1rem;
          color: #024580;
          font-family: Demibold;

          img {
            width: 3rem;
            margin-right: 10px;
          }
        }

        .bottom {
          margin-top: 20px;
          color: #727171;
          font-size: 1.7rem;
          line-height: 2;
        }
      }
    }
  }
}

.application {
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: 100% 100%;
  color: #fff;
  background-image: url('../../static/img/Background2.jpg');

  .or-container {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    height: 60vh;
  }

  .or-container:before {
    background-color: rgba(0, 0, 0, 0.4);
  }

  .box {
    flex: 1;
    overflow: hidden;
    transition: 0.5s;
    box-shadow: 0 20px 30px rgba(0, 0, 0, 0.1);
    line-height: 0;
    height: 100%;
    border-radius: 6px;
    margin: 0 20px;
    position: relative;
  }

  .box:first-child {
    margin: 0 20px 0 0;
  }

  .box:last-child {
    margin: 0 0 0 20px;
  }

  .box > img {
    width: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    transition: 0.5s;
    height: 100%;
  }

  .box > span {
    font-size: 3.8vh;
    display: block;
    text-align: center;
    height: 10vh;
    line-height: 2.6;
  }

  .eleactive {
    flex: 1 1 40%;
  }

  .eleactive > img {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    height: 100%;
    object-fit: cover;
  }

  .eleactive .account {
    opacity: 1;
    transition: all 0.3s;

    span {
      font-size: 1.7rem;
      text-align: left;
      line-height: 1.2;
    }
  }

  .eleactive .bottom {
    opacity: 0;
    transition: all 0.3s;
  }

  .eleactive .top {
    opacity: 1;
    transition: all 0.3s;
  }

  .top {
    opacity: 0;
    position: absolute;
    top: 35px;
    left: 3vh;
    font-size: 2.8rem;
    font-family: Demibold;
    transition: all 0.3s;
  }

  .bottom {
    position: absolute;
    bottom: 35px;
    width: 100%;
    opacity: 1;
    transition: all 0.3s;

    p {
      font-size: 2.8rem;
      font-family: Demibold;
      color: #fff;
      margin: 0 auto;
      text-align: center;
    }
  }

  .account {
    opacity: 0;
    position: absolute;
    left: 3vh;
    top: 80px;
    font-size: 1.7rem;
    font-family: Regular;
    transition: all 0.3s;
  }
}

.contactus {
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: 100% 100%;
  color: #727171;
  background-image: url('../../static/img/Background3.jpg');

  .contactimg {
    border-radius: 6px;
    max-height: 60rem;
  }

  .info_div {
    display: flex;
  }

  .info_p_div {
    margin-bottom: 4rem;

    p {
      margin-bottom: 0;
    }
  }

  .box {
    font-size: 14px;

    img {
      width: 12rem;
    }

    .flex_div {
      display: flex;

      .img_div {
        cursor: pointer;
        width: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 1rem 4rem 1rem 0;
        text-align: center;
        overflow: hidden;

        img {
          width: auto;
          height: 3rem;
          margin-bottom: 1rem;
          transform: translateY(-60px);
          filter: drop-shadow(0 60px 0 #727171);
        }

        &:hover {
          img {
            filter: drop-shadow(0 60px 0 #024580);
          }

        }
      }
    }

    .qiye, .xiaoshou, .dizhi {
      display: flex;
      flex-direction: column;
      margin-bottom: 4rem;
      font-size: 1.7rem;
      font-family: Regular;

      .title {
        margin-right: 3rem;
        font-family: Demibold;
        height: 5rem;
        margin-bottom: 4rem;
      }
    }
  }
}

.img_div2 {
  //width: 18rem !important;
  //height: auto;
}

.home-banner-img {
  width: 100%;
  height: 100%;
  background-color: #FFF;
  object-fit: cover;
  cursor: pointer;
}

.banner-img {
  width: 100%;
  height: 100%;
  background-color: #FFF;
  object-fit: contain;
}

.bannerBackground {
  position: absolute;
  bottom: 0;
  height: 100%;
  z-index: 10;
  width: 100%;
  background-image: linear-gradient(to right, rgba(13, 23, 32, 1) 10%, rgba(13, 23, 32, 0.7) 30%, rgba(13, 23, 32, 0) 60%, rgba(13, 23, 32, 0) 80%, rgba(13, 23, 32, 0.5));
}

.pointer-item {
  cursor: pointer;
}

/deep/ .el-carousel__indicator--horizontal {
  margin: 0 0.6rem;
}

.line-height-zh {
  line-height: 2 !important;
}

.line-height-en {
  line-height: 1.5 !important;
}

.show_pc {
  display: block;
}

.show_phone {
  display: none;
}

@media screen and (max-width: 1400px) {
  .aboutusbtn {
    margin-top: 5rem;
  }

  .aboutus .about .icontext-en .item .bottom {
    margin-top: 1rem;
  }

  .aboutus .about .icontext-en {
    margin-top: 1rem;
  }
}

@media screen and (max-width: 1200px) {
  .contactimg {
    display: none;
  }

  .infoBtn {
    margin-bottom: 3rem;
  }

  .home-title {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .container {
    margin: 0 2rem;
  }

  .aboutus .about {
    border-radius: 6px;
    margin-bottom: 1rem;
    padding: 0 1rem;
  }

  .about-right {
    margin-bottom: 1rem;
  }

  .aboutus .CompanyPhoto {
    border-radius: 6px;
  }

  .dbanner .banner-title .Bold {
    font-size: 2rem;
  }

  .dbanner .banner-title .Regular {
    font-size: 1rem;
  }

  .dbanner .banner-title {
    top: 50%;
  }

  .aboutusbtn-banner {
    display: none;
  }

  .aboutusbtn {
    margin-top: 5rem;
  }

  .phone_el {
    margin-top: 1rem;
  }

  .show_pc {
    display: none;
  }

  .show_phone {
    display: block;
  }

  .moreBtn {
    margin-bottom: 1rem;
  }

  .dbanner .bannerleft {
    left: 0;
  }

  .dbanner .bannerright {
    right: 0;
  }

  .dbanner .banner-title .Bold {
    margin-bottom: 1rem;
  }

  .ditu {
    width: 8rem !important;
    height: 8rem !important;
  }

  .product .banner-right .zhezhao div {
    line-height: 1.2;
  }

  .product .banner-right .zhezhao {
    padding-left: 1rem;
    left: 5px;
    width: calc(100% - 10px);
  }

  .application .bottom {
    display: none;
  }

  .product .banner-right {
    margin-bottom: 1rem;
  }

  .margin-2 {
    margin-left: 2rem;
    margin-right: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue